import React from "react";

import { useHistory } from "react-router";
import logo from "../images/logo.png";

export default function Header(props) {
  const history = useHistory();

  return (
    <div className="Header">
      <div className="Header__Container">
        <img className="Header__Container--Img" onClick={()=>{history.push('/details')}} src={logo} alt="" />
        <button className="Header__Container--Btn" onClick={props.executeScroll}>
         Register Now
        </button>
      </div>
    </div>
  );
}
